/**
 * Page explaning PM fundamentals
 */
export default {
    name: "particulate-matter",
    data: () => ({
    }),
    created: function () {
    }
};